export const DISCOVERY_DOCS = [
  "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
];
export const SCOPES = "https://www.googleapis.com/auth/calendar.readonly";
